/**
 * EventNoteDialog — dialog “Aggiungi trascrizione/nota” a un evento Calendario.
 * ★ Fase 59.P2 — estratto da CalendarPage.jsx. Comportamento e testid invariati.
 */
import React from 'react';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription,
} from '../ui/dialog';
import { fmtDateTime } from '../../lib/constants';
import i18n from '../../i18n';

export function EventNoteDialog({ noteDialog, noteText, setNoteText, onClose, onSave }) {
  return (
    <Dialog open={!!noteDialog} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-md" data-testid="event-note-dialog">
        <DialogHeader>
          <DialogTitle>{i18n.t('calendarX.addNoteTitle', 'Aggiungi trascrizione/nota')}</DialogTitle>
          <DialogDescription>
            {noteDialog?.title} · {noteDialog && fmtDateTime(noteDialog.event_at)}
          </DialogDescription>
        </DialogHeader>
        <div>
          <Label className="text-xs uppercase tracking-wide">{i18n.t('calendarX.noteText', 'Testo nota')} *</Label>
          <Textarea
            rows={5}
            value={noteText}
            onChange={(e) => setNoteText(e.target.value)}
            placeholder={i18n.t('calendarX.noteTextPh', 'Scrivi la trascrizione della call, follow-up, decisioni prese…')}
            className="mt-1"
            data-testid="event-note-text"
            autoFocus
          />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            {i18n.t('common.cancel', 'Annulla')}
          </Button>
          <Button onClick={onSave} disabled={!noteText.trim()} data-testid="event-note-save">
            {i18n.t('calendarX.addNote', 'Aggiungi nota')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
